/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import { elementContentType } from '../../../../../../../../types';

export default class SocialElement extends PureComponent {
    state = {
        align: 'center',
        iconSize: 32,
        iconVersionColor: true,
        icons: [],
        paddingTop: 0,
        paddingRight: 0,
        paddingLeft: 0,
        paddingBottom: 0,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { content } = nextProps;
        const icons = content.icons.filter((icon) => icon.active === true);
        const { align, iconSize, iconVersionColor, paddingTop, paddingRight, paddingLeft, paddingBottom } = content;
        const newState = {
            ...prevState,
            align,
            iconSize,
            iconVersionColor,
            icons,
            paddingTop,
            paddingRight,
            paddingLeft,
            paddingBottom,
        };
        if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
            return { ...newState };
        }

        return { ...prevState };
    }

    render() {
        const { align, iconSize, iconVersionColor, icons, paddingTop, paddingRight, paddingLeft, paddingBottom } =
            this.state;
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <table style={{ width: '100%' }} tabIndex="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td
                            align={align}
                            verticalalign="middle"
                            style={{
                                fontSize: 0,
                                paddingTop,
                                paddingRight,
                                paddingBottom,
                                paddingLeft,
                                wordBreak: 'break-word',
                            }}
                        >
                            <table
                                align={align}
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                role="presentation"
                                style={{ borderCollapse: 'separate', lineHeight: '100%' }}
                            >
                                <tbody>
                                    <tr>
                                        <td align={align} valign="middle" role="presentation">
                                            {icons.map((icon) => {
                                                const src = iconVersionColor ? icon.src.color : icon.src.bw;
                                                return (
                                                    <table
                                                        key={icon.title}
                                                        align={align}
                                                        border="0"
                                                        cellSpacing="0"
                                                        cellPadding="0"
                                                        role="presentation"
                                                        style={{ float: 'none', display: 'inline-table' }}
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: 4 }}>
                                                                    <table
                                                                        align={align}
                                                                        border="0"
                                                                        cellSpacing="0"
                                                                        cellPadding="0"
                                                                        role="presentation"
                                                                        style={{ width: iconSize }}
                                                                    >
                                                                        <tbody>
                                                                            <tr>
                                                                                <td
                                                                                    style={{
                                                                                        fontSize: 0,
                                                                                        height: iconSize,
                                                                                        verticalAlign: 'middle',
                                                                                        width: iconSize,
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={src}
                                                                                        width={iconSize}
                                                                                        height={iconSize}
                                                                                        alt={icon.title}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                );
                                            })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

SocialElement.propTypes = {
    content: elementContentType.isRequired,
};
